module.exports = __webpack_public_path__ + "img/become_part_of_future.cde40cd3.svg";